module.exports = __webpack_public_path__ + "img/full2-min.d8919291.png";